import { render, staticRenderFns } from "./getall.vue?vue&type=template&id=0c13e00b"
import script from "./getall.vue?vue&type=script&lang=js"
export * from "./getall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports